import * as React from 'react';

import styles from './FilterButton.module.scss';

const FilterButton = React.forwardRef<
  HTMLDivElement,
  { children: string | React.ReactNode }
>(({ children, ...props }, ref) => {
  return (
    <div className={styles.filterButton} ref={ref} {...props}>
      <div className={styles.filterButton__content}>{children}</div>
    </div>
  );
});

export { FilterButton };
